//
//  event-bus.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import Vue from 'vue';

const EventBus = new Vue();

export default EventBus;
